/**
 * Table Column Factories
 *
 * Reusable factory functions for creating consistent table columns.
 */

// Unified helper (recommended)
export { createColumn, toTableColumns } from './createColumn';
export type { ColumnConfig, InlineColumnFactory } from './createColumn';

// Column presets for common patterns
export { createCreatedAtColumn, createDateCreatedColumn, createIdColumn, createUpdatedAtColumn } from './presets';

// Individual factories (also available)
export { createCopyableColumn } from './createCopyableColumn';
export { createSortableColumn } from './createSortableColumn';
export { createDateColumn } from './createDateColumn';
export { createBadgeColumn } from './createBadgeColumn';
export { createActionColumn } from './createActionColumn';
export { createCustomColumn } from './createCustomColumn';
export { createDisplayColumn } from './createDisplayColumn';
export { createSelectionColumn } from './createSelectionColumn';
export type { CreateSelectionColumnOptions } from './createSelectionColumn';
export { createExpandColumn } from './createExpandColumn';
export { createBooleanIndicatorColumn } from './createBooleanIndicatorColumn';

export type {
  BaseColumnOptions,
  SortableColumnOptions,
  CopyableCellProps,
  CopyableColumnOptions,
  DateColumnOptions,
  BadgeColumnOptions,
  ActionColumnOptions,
  ActionButton,
  ColumnFactory,
} from './types';

export type { CustomColumnOptions, CustomCellContext } from './createCustomColumn';
export type { DisplayColumnOptions } from './createDisplayColumn';
export type { BooleanIndicatorColumnOptions } from './createBooleanIndicatorColumn';
